import { computed } from "vue";
import stores from "../stores";

export const tokenSessionId = computed(() => stores.getStoresData().setting?.find((s: { key: string }) => s.key === 'publicKey'))
